import {
    temAcesso
} from '@/shared/auth/temAcesso'

const Finalizacoes = () => import('./Finalizacoes.vue')
const Finalizacao = () => import('./Finalizacao.vue')
const FinalizacaoAssociarEntregas = () => import('./FinalizacaoAssociarEntregas.vue')
const FinalizacaoAssociarDespViagens = () => import('./FinalizacaoAssociarDespViagens.vue')
const Entrega = () => import('./../entregas/Entrega.vue')

export default {
    path: 'finalizacoes',
    name: 'Credenciados_Finalizacoes',
    component: Finalizacoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-FORN-FIN-00')) {
            next()
        }
    },
    children: [{
        path: ':finalizacaoId',
        name: 'Credenciados_Finalizacoes_Detalhar',
        component: Finalizacao,
        beforeEnter: (to, from, next) => {
            if (temAcesso('CRED-FORN-FIN-02')) {
                next()
            }
        },
        children: [{
                path: 'associarentregas',
                name: 'Credenciados_Finalizacoes_AssociarEntregas',
                component: FinalizacaoAssociarEntregas,
                beforeEnter: (to, from, next) => {
                    if (temAcesso('CRED-FORN-FIN-03')) {
                        next()
                    }
                }
            },
            {
                path: 'associardespviagens',
                name: 'Credenciados_Finalizacoes_AssociarDespViagens',
                component: FinalizacaoAssociarDespViagens,
                beforeEnter: (to, from, next) => {
                    if (temAcesso('CRED-FORN-FIN-03')) {
                        next()
                    }
                }
            },
            {
                path: ':entregaId',
                name: 'Credenciados_Finalizacoes_Entrega',
                component: Entrega,
                beforeEnter: (to, from, next) => {
                    if (temAcesso('CRED-FORN-ENTR-01')) {
                        next()
                    }
                }
            }
        ]
    }]
}
